import { useMemo } from "react";
import CompanyItem from "../SelectionColumns/CompanyItem";
import { useCompanyKeywordSearch } from "~/features/SearchV3/hooks/useCompanyKeywordSearch";
import useCompanyList from "~/features/SearchV3/hooks/useCompanyList";
import { useHelperStore } from "~/stores";

const KeywordCompanyList = () => {
    const keyword = useHelperStore(state => state.keyword);

    const { filteredCompanies } = useCompanyKeywordSearch();
    const { checkItemSelection, handleCompanySelection, selectedCompanyIds } = useCompanyList();

    const companyList = useMemo(() => {
        return filteredCompanies?.map(item => (
            <CompanyItem
                key={`${item.disclosureId}-${item.id}`}
                companyId={item.companyId}
                isSelected={checkItemSelection(item.companyId)}
                btnClickCallback={handleCompanySelection}
            />
        ));
    }, [filteredCompanies, selectedCompanyIds, keyword]);

    return <div className="flex flex-col gap-1">{companyList}</div>;
};

export default KeywordCompanyList;
